import React from 'react';

/**
 * @deprecated
 * SSRCheck is deprecated and will be removed in the next major version
 */
export const SSRCheck = () => {
  return <div data-ssr />;
};
